import { Component, Inject, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogData } from '@greco-fit/scaffolding';
import { Subscription } from '@greco/sales-subscriptions';
import { SubscriptionsService } from '../../services';

@Component({
  templateUrl: './set-transferred-from.dialog.html',
})
export class SetSubscriptionTransferredFromDialog implements OnInit {
  constructor(
    private subscriptionSvc: SubscriptionsService,
    @Inject(MAT_DIALOG_DATA) private subscription: Subscription,
    private matDialogRef: MatDialogRef<SetSubscriptionTransferredFromDialog>
  ) {
    this.accountId = subscription.accountId;
  }

  readonly simpleDialogData: DialogData = {
    title: 'Transferred From',
    subtitle: "Update the 'Transferred From' property of this subscription with an existing user email.",
    hideDefaultButton: true,
  };

  transferredFromFormControl = new FormControl(null);

  accountId: string;

  cancel() {
    this.matDialogRef.close();
  }

  async submit() {
    try {
      const update = await this.subscriptionSvc.setTransferredFrom(
        this.subscription.id,
        this.transferredFromFormControl.value?.id ?? null
      );
      this.matDialogRef.close(update);
    } catch (err) {
      console.error(err);
    }
  }

  ngOnInit() {
    setTimeout(() => this.transferredFromFormControl.reset(this.subscription.transferredFromId));
  }
}
